import React, { memo } from 'react'
import tw from 'twin.macro'
import { Typography, Link } from '@mui/material'
import { PublicWrapper } from 'src/components/layout/PublicWrapper'
import NotFoundImage from 'src/assets/images/not-found.png'

interface Props {
  flow?: 'client' | 'contractorPortal'
}

const NotFoundPageComponent = ({ flow }: Props) => {
  return (
    <PublicWrapper flow={flow}>
      <div css={tw`h-full flex flex-col justify-between`} data-testid="shared-not-found-page">
        <img src={NotFoundImage} css={tw`h-[220px] w-[280px] self-center`} />
        <div>
          <Typography css={tw`mt-4 text-center`} variant="h2">
            404 - Page not found
          </Typography>
          <Typography css={tw`mb-4 mt-2 text-center text-shades-400`}>
            Oops! It seems you've taken a wrong turn. The page you're looking for is on a coffee
            break. Please check your URL or navigate back to our homepage. We apologize for the
            inconvenience! If the issue persists, contact our{' '}
            <Link
              href="mailto:help@gigsafe.com"
              underline="always"
              css={tw`text-info-500`}
              data-testid="shared-not-found-support-mail-link"
            >
              support team
            </Link>
            .
          </Typography>
        </div>
      </div>
    </PublicWrapper>
  )
}

export const NotFoundPage = memo(NotFoundPageComponent)
